const noteActionTypes = {
  SET_NOTES: "SET_NOTES",
};

export default noteActionTypes;
